import React from 'react';
import ReactModal from 'react-modal';
import { 
    defineMessages,
    FormattedMessage, 
    // intlShape, 
    injectIntl 
} from 'react-intl';
// import { Icon } from 'antd';
import { Icon } from "@chakra-ui/react";
import './drawerComponents.css';
import bindAll from 'lodash.bindall';
import wifiConnectErrorIcon from './wifiConnectErrorIcon.png'


const messages = defineMessages({
});

// wifi连接

class WifiConnectLoadModal extends React.Component {

    constructor(props) {
        super(props);
        bindAll(this, [
        ]);
    }

    componentDidMount() {
    }
    render() {
        const { intl, ...props } = this.props;
        return (
            <ReactModal 
                isOpen
                overlayClassName="modalOverlay"
                className="modalContentLoad"
                ariaHideApp={false} 
            >
                <div>
                    <div className="wifiConnectLoad">
                        <img src={wifiConnectErrorIcon} />
                        <div className="wifiConncetWord">
                            <FormattedMessage
                                defaultMessage="Please enter the correct WiFi account and password"
                                description="Please enter the correct WiFi account and password"
                                id="gui.homePage.camNousWifiConnectError"
                            />
                        </div>
                    </div>
                </div>
            </ReactModal>
        );
    }
}
WifiConnectLoadModal.propTypes = {
    // intl: intlShape
};

export default injectIntl(WifiConnectLoadModal);
